import PropTypes from "prop-types";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Asks which of the entity's active campaigns a new Revenue Opportunity
 * belongs to. None is an explicit choice, apart from Cancel, which abandons
 * the create flow.
 */
const CampaignPickerDialog = ({ open, campaigns, onSelect, onCancel }) => (
  <Dialog open={open} onOpenChange={next => !next && onCancel()}>
    <DialogContent className="tw:sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Select a Campaign</DialogTitle>
        <DialogDescription>
          This entity belongs to several active campaigns. Choose the campaign
          for the new Revenue Opportunity, or None.
        </DialogDescription>
      </DialogHeader>
      <div className="tw:flex tw:max-h-80 tw:flex-col tw:gap-2 tw:overflow-y-auto">
        {campaigns.map(campaign => (
          <Button
            key={campaign.id}
            variant="outline"
            className="tw:justify-start"
            onClick={() => onSelect(campaign.id)}
          >
            {campaign.name}
          </Button>
        ))}
        <Button
          variant="outline"
          className="tw:justify-start tw:italic"
          onClick={() => onSelect(null)}
        >
          None
        </Button>
      </div>
      <DialogFooter>
        <DialogClose render={<Button variant="outline">Cancel</Button>} />
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

CampaignPickerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  campaigns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CampaignPickerDialog;
